import React, { useEffect } from "react";
import { useOnboarding } from "src/store/features/onboarding.slice";
import * as Yup from "yup";
import { rejectPoBox } from "src/utils/poBox";

export const isValidNumber = (value: string | undefined) => {
  return value !== "" && !isNaN(Number(value));
};

export default function ReKycApplicationConfig() {
  const { reKycApplicationStep } = useOnboarding();
  const [validationSchema, setValidationSchema] = React.useState<Yup.ObjectSchema<any>>(
    Yup.object(),
  );

  const RekycAboutYouValidationSchema = Yup.object().shape({
    firstname: Yup.string().required("First name is required"),
    lastname: Yup.string().required("Last name is required"),
    occupation: Yup.string().required("Occupation is required"),
    nationality: Yup.string().required("nationality is required"),
    country: Yup.string().required("Country is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    address: Yup.string().required("State is required"),
    postCode: Yup.string()
      .required("Post code is required")
      .max(10, "Post code must be 10 digits or lower"),
    streetAddress: rejectPoBox(Yup.string().required("Street Address is required")),
    unitApartment: rejectPoBox(),
    ssn: Yup.string()
      .min(9, "SSN must be at least 9 digits")
      .max(11, "SSN must be up to 11 digits if hyphens are included"),
  });

  const reKycEntityValidationSchema = Yup.object().shape({
    reKycEntityId: Yup.string()
      .required("Identification number is required")
      .max(20, "ID must be 20 digits or lower"),
    registeredOfficeCountry: Yup.string().required("Country is required"),
    registeredOfficeStreet: rejectPoBox(Yup.string().required("Street Address is required")),
    registeredOfficeunitApartment: rejectPoBox(),
    registeredOfficeState: Yup.string().required("State is required"),
    registeredOfficePostcode: Yup.string()
      .required("Post code is required")
      .max(10, "Post code must be 10 digits or lower"),
    placeOfBusinessCountry: Yup.string().required("Country is required"),
    placeOfBusinessStreet: rejectPoBox(Yup.string().required("Street Address is required")),
    placeOfBusinessunitApartment: rejectPoBox(),
    placeOfBusinessState: Yup.string().required("State is required"),
    placeOfBusinessPostCode: Yup.string()
      .required("Post code is required")
      .max(10, "Post code must be 10 digits or lower"),
  });

  useEffect(() => {
    if ("aboutYou" === reKycApplicationStep) setValidationSchema(RekycAboutYouValidationSchema);
    if ("aboutYourEntity" === reKycApplicationStep)
      setValidationSchema(reKycEntityValidationSchema);
  }, [reKycApplicationStep]);

  return [validationSchema];
}
